import { createDownloadableLink } from '@/helpers';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  getTestsSuccess: (data, key) => ({ data, key }),
  getTests:
    (search, paging, category) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().service[category].paging;
      let { result, status } = await Api.get(`tests`, {
        pageIndex: pagingData.pageIndex,
        pageSize: pagingData.pageSize,
        search,
        category,
      });
      status === 200 && serviceDispatcher.getTestsSuccess(result, category);
    },
  getAllServices:
    (category, isAssigned = true, callback, projectId = '') =>
    async ({ Api }) => {
      if (!category) return;
      let { result, status } = await Api.get(`tests`, {
        category,
        isAssigned,
        projectId,
      });
      status === 200 && callback && callback(result.list);
    },
  getAllServicesWithNoneStation:
    (category, callback) =>
    async ({ Api }) => {
      if (!category) return;
      let { result, status } = await Api.get(`tests`, {
        category,
      });
      status === 200 && callback && callback(result.list);
    },
  getServiceByID:
    (id, callback) =>
    async ({ Api }) => {
      let { result, status } = await Api.get(`tests/${id}`);
      status === 200 && callback && callback(result);
    },
  setState: (state, value) => ({ state, value }),
  createTest:
    (data, category, callbackSuccess) =>
    async ({ Api, customToast }) => {
      const { status } = await Api.post('tests', {
        ...data,
        category,
      });
      serviceDispatcher.setState('loading', false);
      if (status === 200) {
        callbackSuccess && callbackSuccess();
      }
    },

  editTest:
    (payload, category, callbackSuccess) =>
    async ({ Api }) => {
      const { id } = payload;
      const { status } = await Api.put(`tests/${id}`, {
        ...payload,
        category,
      });
      serviceDispatcher.setState('loading', false);
      if (status === 200) {
        callbackSuccess && callbackSuccess();
      }
    },
  deleteTest:
    (id, callbackSuccess) =>
    async ({ Api, customToast }) => {
      const { status } = await Api.delete(`tests/${id}`);
      if (status === 200) {
        customToast('success', 'Deleted successful');
        callbackSuccess && callbackSuccess();
      }
    },
  getExportExcel:
    (category, search) =>
    async ({ Api }) => {
      let { result, status } = await Api.post(`tests/exports/csv`, {
        category,
        search,
      });
      status === 200 && createDownloadableLink(result, `${category}-report`);
    },
};

const serviceDispatcher = synthesize('service', mapDispatchToAC);
export default serviceDispatcher;
